<template>
  <div class="mb-5">
    <div v-if="!pathMixin_isBookingPageWithoutTravelerBar && !hasTrip">
      <WhosTraveling></WhosTraveling>
    </div>
    <div v-if="hasTrip" class="container my-5">
      <div class="columns is-centered">
        <div class="column is-narrow has-text-centered">
          <img :src="tripPhotoUrl" class="trip-photo" />
        </div>

        <div class="column is-narrow has-text-centered">
          <div
            class="is-size-4 has-text-primary has-text-weight-medium"
          >
            {{ tripName }}
            <span class="is-size-6 has-text-weight-light has-text-grey"
              >( {{ trip.recordLocator }} )</span
            >
          </div>

          <h3
            class="is-size-5 has-text-weight-light has-text-grey"
          >
            <span>{{ trip.startDate | formatDate }} </span>
            <span v-if="trip.startDate != trip.endDate"
              >- {{ trip.endDate | formatDate }}</span
            >
          </h3>

          <div v-if="useAtcShopper" class="column is-narrow has-text-centered">
          <b-button type="is-primary is-outline" icon-right="close" @click="cancelExchange" expanded outlined> Cancel Ticket Exchange </b-button>
        </div>

          <div v-else>
          <span
            class="is-size-7 has-text-weight-light has-text-primary"
            @click="checkMove"
            style="cursor:pointer"
          >
            Book as a new trip<b-icon icon="arrow-right" size="is-small"></b-icon>
          </span>
          </div>



        </div>
      </div>
    </div>

    <div class="mb-5"></div>
    <router-view></router-view>
  </div>
</template>

<script>
import WhosTraveling from "@/components/BookTravel/WhosTraveling";
import bookingMixin from "@/mixins/bookingMixin";

export default {
  name: "BookTravel",
  mixins: [bookingMixin],
  components: {
    WhosTraveling,
  },
  props: {},
  computed: {
    useAtcShopper() {
      return this.$store.state.bookTravel.atc?.useAtcShopper;
    },
    tripName() {
      if (this.trip.tripSummary?.tripName) {
        return this.trip.tripSummary.tripName;
      } else if (this.trip.tripSummary?.cityState) {
        return "Updating trip to " + this.trip.tripSummary.cityState;
      } else {
        return "Updating existing trip";
      }
    },
    route() {
      return this.$route;
    },
    trip() {
      return this.$store.state.bookTravel.result.trip;
    },
    hasTrip() {
      return !this.$helpers.isEmptyObject(this.trip) && this.trip !== null;
    },
    tripPhotoUrl() {
      return this.trip && this.trip.tripSummary && this.trip.tripSummary.photoUrl;
    },
  },
  methods: {
    notEmptyObject(obj) {
      return Object.keys(obj).length > 0;
    },
    checkMove() {
      this.$buefy.dialog.confirm({
        message:
          "You are currently updating an existing trip. Would you like to transfer your current booking details to a new trip?",
        confirmText: "Book as a new trip",
        cancelText: "Cancel",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.clearTrip(),
      });
    },
    clearTrip() {
      this.$store.dispatch("bookTravel/setTripResult", {});
    },
    cancelExchange() {
      this.$store.dispatch("bookTravel/setAtcDetails", {});
      this.$router.push({ name: "planned-trips" });
    },
  },
};
</script>

<style scoped>
.trip-photo {
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
  width: 100%;
  max-width: 200px;
}
</style>
